import { BatterySelector } from "../BatterySelector";
import useMoveVirtualBatteryContext from "../useMoveVirtualBatteryContext";
import { FC } from "react";
import { useVirtualBatteries } from "@/components/VirtualBattery/hooks/useVirtualBatteries";
import { BatteryDistribution } from "@/components/VirtualBattery/types/percentages";

interface MoveVirtualBatteryStep1Params {
  
}

export const MoveVirtualBatteryStep1: FC<MoveVirtualBatteryStep1Params> = ({
  // nextStepCallback
}) => {
  const {
    bateriaVirtualToMove,
    selectedBatteryId,
    setSelectedBatteryDistribution,
  } = useMoveVirtualBatteryContext();

  const {
    isFetchingBateriaVirtualPercentages,
    bateriaVirtualPercentages
  } = useVirtualBatteries();

  const handleSelectedBattery = (batteryDistribution: BatteryDistribution) => {
    setSelectedBatteryDistribution(batteryDistribution);
    // nextStepCallback();
  }

  if (!isFetchingBateriaVirtualPercentages && !bateriaVirtualPercentages || !bateriaVirtualToMove) {
    return "No batteries available";
  }

  return <BatterySelector
    selectedBatteryId={selectedBatteryId}
    onSelected={handleSelectedBattery}
    excludeBatteryId={bateriaVirtualToMove.bateria.id}
  />;
};

export default MoveVirtualBatteryStep1;
